import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import _ from "lodash"

import { Button, Table } from '../../helpers';
import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog"
import { Tooltip } from "primereact/tooltip";
import { Chip } from "primereact/chip";

import Loading from "../../common/Loading";
import AddBankAccount from "../../common/AddBankAccount";
import Steps from "../../helpers/Steps";
import EditBankAccont from "./Components/EditBankAccount";

import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchApprovals, fetchApprovalSecondary, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getCompanyWithGSTIN } from "../../services/api/company";
import {
    insertCompanyBankAccount,
    updateCompanyBankAccountStatus,
    updateCompanyBankAccount
} from "../../services/api/companyBankAccount";
import { getApprovalInstancesByCompanyId } from "../../services/api/approvalInstances";

import { checkPermissions, getApproverDetails, getFullName, sortArrayOfObjectsInAscendingDateOrder } from "../../utils";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";

import "./index.css"


const CompanyBankDetails = () => {
    const { id } = useParams()
    
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const toast = useRef(null)

    const [addAccountModalVisible, setAddAccountModalVisible] = useState(false)
    const [bankAccounts, setBankAccounts] = useState([])
    const [companyData, setCompanyData] = useState({})
    const [isLoaderVisible, setIsLoaderVisible] = useState(true)
    const [bankApprovalInstances, setBankApprovalInstances] = useState([])
    const [editBankAccountVisible, setEditBankAccountVisible] = useState(false)
    const [editBankAccount, setEditBankAccount] = useState({})

    const userDetails = useSelector((state) => state.userDetails)
    const approvals = useSelector((state) => state.common.approvals)
    const approvalSecondary = useSelector((state) => state.common.approvalSecondary)
    const statusList = useSelector((state) => state.common.status)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    useEffect(() => {
        dispatch(fetchApprovals())
        dispatch(fetchApprovalSecondary())
        dispatch(fetchStatus())
        getCompnayData()
    }, [])

    const items = [
        {
            label: 'Company Details',
            command: () => { navigate(`/company/${id}`); }
        },
        {
            label: 'Users',
            command: () => { navigate(`/company/users/${id}`); }
        },
        {
            label: 'Branch',
            command: () => { navigate(`/company/branches/${id}`); }
        },
        {
            label: 'Bank Accounts',
            command: () => { navigate(`/company/bank_details/${id}`); }
        },
        {
            label: 'Rate Contract',
            command: () => { navigate(`/company/ratecontract/${id}`); } 
        }
    ]

    if([2, 3].includes(companyData?.buyerSeller)){
        items.push(
            {
                label: 'Seller Profile',
                command: () => { navigate(`/company/seller-profile/${id}`); } 
            }
        )
    }

    const getCompnayData = async () => {
        const company_id = id
        const companyData = await getCompanyWithGSTIN(company_id)

        console.log("companyData-reponse", companyData)

        if (companyData.status == 1) {
            setIsLoaderVisible(false)
            const company_data = companyData.data
            if (company_data) {
                setCompanyData(company_data)
                if (company_data.companyBankAccounts) {
                    setBankAccounts(company_data.companyBankAccounts)
                    await getApprovalInstances()
                }
            }
        }
    }

    const dispalyApproverDetails = (allApprovers) => {
        let approverNames = []
        allApprovers.map(eachApprover => {
            approverNames.push(eachApprover.fullName)
        })
        return approverNames.join(", ")
    }

    const getApprovalInstances = async() => {
        const relatedCompanyBankApprovals = approvals.filter(eachApproval => pmCompanyConfig.companyBankApprovalTypeIds.includes(eachApproval.approvalTypeId))
        const relatedCompanyBankApprovalIds = relatedCompanyBankApprovals.map(eachApproval => eachApproval.approvalId)
        let data = {
            companyType: "sellerCompanyId",
            approvalIds: relatedCompanyBankApprovalIds
        }
        const approvalInstancesResponse = await getApprovalInstancesByCompanyId(id, data)
        console.log("approvalInstancesResponse", approvalInstancesResponse)
        if (approvalInstancesResponse?.failure){
            return dispatch(raiseToast({ severity: 'error', detail: approvalInstancesResponse?.data?.error, life: 3000 }))
        }else{        
            setBankApprovalInstances([...approvalInstancesResponse.data])
        }
    }

    const getApprovarDetailsData = (selectedApprovalId) => {
        let relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === selectedApprovalId)
        const pmCompanyUsers = userDetails?.PMCompanyDetails?.companyUsers ? userDetails?.PMCompanyDetails?.companyUsers : []
        const pmCompanyRoles = userDetails?.PMCompanyDetails?.companyRoles ? userDetails?.PMCompanyDetails?.companyRoles : []
        const pmBranches = userDetails?.PMCompanyDetails?.companyBranches ? userDetails?.PMCompanyDetails?.companyBranches : []

        const pmBranchId = null
        const createdBy = null
        if(relatedApproval){
            const approvalDetails = getApproverDetails(relatedApproval, pmBranchId, createdBy, pmCompanyUsers, pmCompanyRoles, pmBranches, approvalSecondary)
            return approvalDetails
        } else {
            return []
        }
    }

    const renderApprovalDetailsDisplay = (relatedApprovalInstance, approvalTypeId, bankAccountId) => {
        let approvalInstanceStatus = statusList.find((status) => status.statusId == relatedApprovalInstance.statusId)?.status

        let approvalDetails = getApprovarDetailsData(approvalTypeId)

        return (
            <div className="md:col-1 lg:col-1 pl-1 flex py-0">
                <Tooltip target={`.custom-tool-tip-company-bank-account-approval-status${bankAccountId}`} position="top" autoHide >
                    <p className='m-0'><b>Approver:</b>  {dispalyApproverDetails(approvalDetails)} </p>
                    <p className='m-0'><b>Status:</b>  {approvalInstanceStatus} </p>
                    { approvalTypeId === 38 && approvalInstanceStatus === "REJECTED" ? <p className='m-0'><b>Remarks: </b>  {relatedApprovalInstance.processedRemarks} </p> : ""}
                </Tooltip>
                <img src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/0370048a-e0db-4fa2-9ef9-ab84df0af52a.png" className={`text-xs mb-1 mr-2 custom-tool-tip-company-bank-account-approval-status${bankAccountId} cursor-auto`} style={{ height: "30px", width: "25px", marginTop:"10px"}} />
            </div>
        )
    }

    const insertBankAccount = async (bankAccountDataObj) => {
        let newBankAccountData = {
            bankName: bankAccountDataObj.bankName,
            holderName: bankAccountDataObj.holderName,
            accNo: bankAccountDataObj.accNo,
            ifscCode: bankAccountDataObj.ifscCode,
            branchId: bankAccountDataObj.branchId,
            documentProof: bankAccountDataObj.documentProof,
            companyId: id,
            statusId: 1,
            buyerSeller: companyData.buyerSeller       
        }

        if([2,3].includes(companyData.buyerSeller) && bankAccountDataObj.bankAccountApprovalRemarks){
            newBankAccountData.bankAccountApprovalRemarks = bankAccountDataObj.bankAccountApprovalRemarks
        }
        
        if (!newBankAccountData.documentProof) {
            return toast.current.show({ severity: 'warn', detail: "Please upload bank document proof", life: 3000 })
        }

        if (window.confirm("Do you want to add the bank account..?")) {
            setIsLoaderVisible(true)
            const response = await insertCompanyBankAccount(newBankAccountData)
            console.log("insertBankAccount - result", response)
            setIsLoaderVisible(false)
            if(response.failure){
                return dispatch(raiseToast({ severity:'warn', summary: response.data.error, life: 3000}))
            }else{
                setBankAccounts([...bankAccounts, response.data])
                setAddAccountModalVisible(false)
                await getApprovalInstances()
                return dispatch(raiseToast({ severity: 'success', detail: "Bank account added successfully", life: 3000 }))
            }
        }
    }

    const handleDeleteBankAccount = async (bankAccountId) => {
        let updateObj = {
            statusId: 2
        }

        if (window.confirm("Do you want to delete bank account..?")) {
            setIsLoaderVisible(true)
            const response = await updateCompanyBankAccountStatus(bankAccountId, updateObj)
            console.log("deleteBankAccount - result", response)
            setIsLoaderVisible(false)
            if (response.failure){
                return dispatch(raiseToast({ severity: 'error', detail: response?.data?.error, life: 3000 }))
            }

            let relatedBankAccounts = bankAccounts.filter(account => account.bankAccId !== bankAccountId)
            setBankAccounts([...relatedBankAccounts])
            return dispatch(raiseToast({ severity: 'success', detail: 'Bank Account Deleted Successfully' }))
        }
    }

    const handleOnClickEditBankAccount = (row) => {
        setEditBankAccount({ ...row, confirmAccountNo: row.accNo, buyerSeller: companyData.buyerSeller })
        setEditBankAccountVisible(true)
    }

    const deleteBankAccount = (rowData) => {
        return <Button style={{ backgroundColor: "transparent", border: "transparent" }} permissions={[234]} onClick={() => handleDeleteBankAccount(rowData.bankAccId)} disabled={companyData.statusId === 2} ><i className='pi pi-minus-circle ' style={{ color: "#00baaa", fontSize: '1.2rem' }}></i></Button>
    }

    const viewBankDocumentProof = (rowData) => {
        return rowData.documentProof ? <a href={rowData.documentProof} className="view-btn" target="_blank">View</a> : "-"
    }

    const handleBranchChange = async (event, selectedBankAccountId) => {
        let relatedBankAccount = bankAccounts.find(account => account.bankAccId === selectedBankAccountId)

        let updateObj = {}
        let confirmMessageType = "add"
        if (relatedBankAccount) {
            if (event.target.value?.length < relatedBankAccount.branchId?.length) {
                confirmMessageType = "remove"
            }

            if (event.target.value?.length === 0) {
                return dispatch(raiseToast({ severity: 'warn', detail: 'Cant remove the branch. Atleast one branch should be selected.', life: 3000 }))
            } else {
                relatedBankAccount.branchId = event.target.value
                updateObj.branchId = event.target.value
            }
        }

        if (window.confirm(`Are you sure you want to ${confirmMessageType} branch`)) {
            setIsLoaderVisible(true)
            const response = await updateCompanyBankAccount(selectedBankAccountId, updateObj)
            console.log("updateCompanyBankAccount - result", response)

            if (response.status === 200) {
                setBankAccounts([...bankAccounts])
                dispatch(raiseToast({ severity: 'success', detail: `Branch ${confirmMessageType === 'add' ? "Added" : "removed"} Successfully.`, life: 3000 }))
            }

            setIsLoaderVisible(false)
        }
    }

    const handleUpdateBankAccount = async (bankAccountDetails) => {
        if (window.confirm(`Are you sure you want to update branch`)) {
            setIsLoaderVisible(true)
            const updateBankAccountResponse = await updateCompanyBankAccount(bankAccountDetails.bankAccId, bankAccountDetails)
            console.log("updateCompanyBankAccount - response", updateBankAccountResponse)
            setIsLoaderVisible(false)
            if (updateBankAccountResponse.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: updateBankAccountResponse?.data?.error, life: 3000 }))
            }

            let updatedBankAccounts = bankAccounts.map(eachBankAccount => {
                if (eachBankAccount.bankAccId === bankAccountDetails.bankAccId) {
                    return { ...updateBankAccountResponse.data }
                }
                return { ...eachBankAccount }
            })

            setBankAccounts(updatedBankAccounts)
            setEditBankAccount(null)
            setEditBankAccountVisible(false)
            await getApprovalInstances()
            dispatch(raiseToast({ severity: 'success', detail: "Bank account updated successfully", life: 3000 }))
        }
    }

    const branchData = (rowData) => {
        const relatedCompanyBranches = companyData.companyBranches.filter(eachBranch => rowData.branchId.includes(eachBranch.branchId))
        const branchNames = _.uniqBy(_.map(relatedCompanyBranches, "branchName"))

        if (branchNames && branchNames.length) {
            return (
                <div className="company-perm-roles">
                    {
                        branchNames.map((eachAttribute, index) => {
                            return eachAttribute ? (
                                <Chip
                                    key={index}
                                    label={eachAttribute}
                                    className="mr-1 mb-1"
                                />
                            ) : "-"
                        })
                    }
                </div>
            )
        }

        return "-"
    }

    const bankNameBody = (rowData) => {
        let latestBankApprovalInstance = null
        if (bankApprovalInstances.length > 0) {
            let relatedBankAccountApprovalInstances = bankApprovalInstances.filter(eachInstance => eachInstance.referenceId === rowData.bankAccId)
            let sortedBankAccountApprovalInstancesByDate = sortArrayOfObjectsInAscendingDateOrder(relatedBankAccountApprovalInstances, "createdAt", "DESC")
            if (sortedBankAccountApprovalInstancesByDate) {
                latestBankApprovalInstance = sortedBankAccountApprovalInstancesByDate[0]
            }
        }

        return (
            <div className="flex justify-content-center align-items-center">
                {rowData.bankName}
                {
                    latestBankApprovalInstance && [8, 12].includes(latestBankApprovalInstance?.statusId) ? renderApprovalDetailsDisplay(latestBankApprovalInstance, 46, rowData.bankAccId) : null
                }
            </div>
        )
    }

    const IFSCCodeBody = (row) => {
        return (
            <>{row.ifscCode}</>
        )
    }

    const bankDetailsAddedByBody = (row) => {
        const relatedCreatedByUser = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === row.createdBy)
        if(!relatedCreatedByUser){
            return <>-</>
        }
        return (
            <div>{getFullName(relatedCreatedByUser.firstName, relatedCreatedByUser.lastName)}</div>
        )
    }

    const editBankAccountBody  = (row) => {
        return <i className="pi pi-file-edit" onClick={()=> handleOnClickEditBankAccount(row)} style={{fontSize : "20px", cursor: "pointer"}}></i>
    }

    const tableColumns = [
        {
            header: 'Bank Name',
            field: 'bankName',
            body: bankNameBody,
            style: { minWidth: '150px' }
        },
        {
            header: 'Holder Name',
            field: 'holderName',
            style: { minWidth: '150px' }
        },
        {
            header: 'Account No',
            field: 'accNo',
            style: { minWidth: '150px' }
        },
        {
            header: `${pmCompanyConfig.bankAccountCode}`,
            field: 'ifscCode',
            body: IFSCCodeBody,
            style: { minWidth: '150px' },
        },
        {
            header: 'Branch',
            field: 'branchId',
            style: { maxWidth: '200px' },
            body: branchData
        },
        {
            header: 'Bank Document',
            field: 'documentProof',
            style: { minWidth: '100px' },
            body: viewBankDocumentProof
        },
        {
            header: 'Added By',
            field: '',
            style: { minWidth: '100px' },
            body: bankDetailsAddedByBody
        },
        {
            header: 'Edit',
            field: 'edit',
            style: { minWidth: '50px' },
            body: editBankAccountBody
        },
        {
            header: 'Delete',
            field: 'delete',
            style: { minWidth: '80px' },
            body: deleteBankAccount
        }
    ]
    

    let addButtonTooltipTxt = ""
    if (companyData.statusId === 2){
        addButtonTooltipTxt = "Add bank is disabled because the company is inactive."
    }

    return (
        <div className="container relative">
            <div className="company-step-header" style={{ top: 50 }}>
                <Steps model={items} activeIndex={3} readOnly={false} />
            </div>
            <Toast ref={toast} />
            <div className="p-card" style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px"}}>
                <div className="flex justify-content-between mt-1 mb-2">
                    <h4 className=" font-bold mb-2">{companyData?.companyName}</h4>
                    <div>
                        <Button className="small-btn" onClick={() => setAddAccountModalVisible(true)} permissions={[146]} disabled={companyData.statusId === 2} tooltip={addButtonTooltipTxt} tooltipOptions={{position: "top", showOnDisabled: true}}><i className='pi pi-plus-circle mr-1' /> Add</Button>
                    </div>
                </div>
                <div className="bank-account-table">
                    <Table tableColumns={tableColumns} data={bankAccounts} rows={10} scrollable={"true"} scrollHeight={"600px"} />
                </div>
                <Dialog className="add-bank-account-dialog" header="Add Bank Account" visible={addAccountModalVisible} style={{ width: '', minHeight: "35%" }} onHide={() => setAddAccountModalVisible(false)}>
                    <AddBankAccount insertBankAccount={insertBankAccount} companyBranches={companyData.companyBranches} companyData={companyData} />
                </Dialog>
                <EditBankAccont
                    editBankAccountVisible={editBankAccountVisible}
                    setEditBankAccountVisible={setEditBankAccountVisible}
                    editBankAccount={editBankAccount}
                    setEditBankAccount={setEditBankAccount}
                    companyData={companyData}
                    companyBranches={companyData.companyBranches}
                    handleUpdateBankAccount={handleUpdateBankAccount}
                    setBankAccounts={setBankAccounts}
                    getApprovalInstances={getApprovalInstances}
                    bankAccounts={bankAccounts}
                    bankApprovalInstances={bankApprovalInstances}
                    pmCompanyConfig={pmCompanyConfig}
                />
            </div>
            <Loading visible={isLoaderVisible} />
        </div>
    )
}

export default CompanyBankDetails;